import React from 'react';

export default function TasksIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor' fillRule='nonzero'>
        <path d='M6.983 11.8c.513 0 .936.386.994.883l.006.117v10.195c0 .513.386.935.884.993l.116.007h9.543c.553 0 1 .447 1 1 0 .513-.386.935-.883.993l-.117.007H8.983c-1.597 0-2.903-1.25-2.995-2.824l-.005-.176V12.8c0-.552.448-1 1-1zM20 6c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L20 8h-8v12h12v-3l.007-.117c.057-.497.48-.883.993-.883s.936.386.993.883L26 17v3c0 1.105-.895 2-2 2H12c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2h8zm6.435 1.828c.39.391.39 1.024 0 1.415l-7.071 7.07c-.15.15-.336.243-.53.278l-.118.014h-.118c-.236-.014-.468-.111-.648-.291l-3.536-3.536c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0l2.828 2.828 6.365-6.364c.39-.39 1.024-.39 1.414 0z' />
      </g>
    </svg>
  );
}
